import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const TecDocIntegration = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        TecDoc Entegrasyonu
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>TecDoc/dat.de entegrasyonu burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default TecDocIntegration;
